import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeTerminationTypeEnum,
  EmployeeTerminationTypeInfo,
} from '@qaroni-app/employee/types/employee-termination-type.enum';

@Pipe({
  name: 'employeeContractTerminationType',
  standalone: false,
})
export class EmployeeContractTerminationTypePipe implements PipeTransform {
  transform(value: EmployeeTerminationTypeEnum): string {
    return value &&
      Object.prototype.hasOwnProperty.call(EmployeeTerminationTypeInfo, value)
      ? EmployeeTerminationTypeInfo[value].name
      : value;
  }
}
